import { useFormik } from "formik";

type ISearchBills = {
    _handleSearch: any,
    _handleError: any,
    loading: boolean
}

const Search = (props: ISearchBills) => {
    const { _handleSearch, _handleError, loading } = props;

    const initialValues = {
        solicitud: '',
        rol: '',
        shipping_start_date: '',
        shipping_end_date: ''
    }

    const formik = useFormik({
        initialValues,
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: async (values, { setStatus }) => {
            try {
                setStatus("")
                const { isValid, error } = _handleValidations(values);

                if (!isValid) {
                    setStatus(error)
                    throw new Error(error);
                }

                setStatus("success")
                await _handleSearch(values);
            } catch (e: any) {
                _handleError(e)
            }
        }
    })

    const _handleValidations = (payload: any) => {
        const errors: any = {};
        if (payload?.solicitud === '') {
            errors.solicitud = 'Campo requerido'
        }
        if (payload?.rol === '') {
            errors.rol = 'Campo requerido'
        }
        if (payload?.shipping_start_date === '') {
            errors.shipping_start_date = 'Campo requerido'
        }
        if (payload?.shipping_end_date === '') {
            errors.shipping_end_date = 'Campo requerido'
        }

        if (Object.keys(errors).length === 4) {
            return { isValid: false, error: "Debe ingresar al menos un filtro" };
        }

        if ((!errors.shipping_start_date && errors.shipping_end_date) || (errors.shipping_start_date && !errors.shipping_end_date)) {
            return { isValid: false, error: "Debe ingresar ambas fechas" };
        }

        return { isValid: true, error: "" };
    }
    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="card p-10">
                <div className="row fs-4 fw-bold">

                    {formik.status && formik.status !== 'success' ? (
                        <div className="col-12 mb-5">
                            <div className="alert alert-danger fs-7" role="alert">
                                {formik.status}
                            </div>
                        </div>
                    ) : null}

                    <div className="col-12 col-md-3 mb-5">
                        N° Solicitud*
                        <input type="text" className="form-control" {...formik.getFieldProps("solicitud")} />
                    </div>

                    <div className="col-12 col-md-3 mb-5">
                        ROL*
                        <input type="text" className="form-control" {...formik.getFieldProps("rol")} />
                    </div>

                    <div className="col-12 col-md-3 mb-5">
                        Fecha Desde*
                        <input type="date" className="form-control" {...formik.getFieldProps("shipping_start_date")} />
                    </div>

                    <div className="col-12 col-md-3 mb-10">
                        Fecha Hasta*
                        <input type="date" className="form-control" {...formik.getFieldProps("shipping_end_date")} />
                    </div>

                    <div className="col-12 text-end">
                        <button type="submit" className="btn btn-sm fw-bold btn-primaryamsm" disabled={loading}>Buscar</button>
                    </div>
                </div>
            </div>
        </form>
    );
}

export default Search;